<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
  import browser from '@/utils/browser.js'

  /* import header from "./pages/layout/header"; */
  import '@/assets/css/reset.less'
  import '@/assets/css/public.less'
  import '@/assets/css/color.less'



  export default {
    provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isMobile: browser.mobile,
        isRouterAlive: true //控制视图是否显示的变量
      }
    },
    methods: {
      async getList() {
        let res = await this.$http({
          method: "get",
          url: `data.json`
        });
        this.$store.commit('getList', res.list);
        console.log(this.$store.state.list)
      },
      reload() {
        this.isRouterAlive = false; //先关闭，
        this.$nextTick(function () {
          this.isRouterAlive = true; //再打开
        })
      }
    },
    created() {
      console.log(this)
      console.log(this.$data)
      this.getList();
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        this.$store.state.aside = false;
      }
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("store", JSON.stringify(this.$store.state))

      })
    }

  }
</script>

<style lang="less">
  * {
    margin:0;
    padding:0;
    list-style:none;
  }
  img {
    width:100%;
    max-width:100%;
  }
  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
